<span class="flex-1">
    <ng-content></ng-content>
</span>
<ng-container>
    <small class="text-color-secondary">{{ localizationLanguageLabel() }}</small>
</ng-container>
